export default {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT'
}